export const PointFive = () => (
	<svg width="50" height="58" viewBox="0 0 50 58" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_dd_25188_21640)">
			<path
				d="M40 19.75C40 32.6875 25 40 25 40C25 40 10 32.4062 10 19.75C10 11.0515 16.7157 4 25 4C33.2843 4 40 11.0515 40 19.75Z"
				fill="#58595B"
			/>
		</g>
		<path
			d="M24.9999 28.7319C21.3277 28.7319 18.0114 26.6543 16.3797 23.4457C16.0563 22.8107 16.3611 22.0364 17.0344 21.8041C17.5818 21.615 18.1892 21.8544 18.4508 22.3717C19.6862 24.8146 22.2074 26.3973 24.9999 26.3973C27.7928 26.3973 30.3137 24.8146 31.5491 22.3717C31.8109 21.8544 32.4184 21.6149 32.9657 21.8041C33.639 22.0364 33.9436 22.8107 33.6204 23.4457C31.9885 26.6543 28.6725 28.7319 24.9999 28.7319Z"
			fill="#62BB46"
		/>
		<path
			d="M29.4243 19.0854C29.4243 21.4128 27.4951 23.0331 25.0667 23.0331C23.4302 23.0331 22.087 22.3091 21.2601 21.1885C21.1394 21.0161 21.0532 20.7748 21.0532 20.5504C21.0532 19.9645 21.5357 19.4818 22.1385 19.4818C22.4487 19.4818 22.7412 19.6197 22.9135 19.8267C23.465 20.4817 24.102 20.8779 24.9977 20.8779C26.1863 20.8779 27.0301 20.1885 27.0301 19.1198C27.0301 18.0508 26.2378 17.482 24.7048 17.482H23.2237C22.552 17.482 22.0525 16.9819 22.0525 16.3097V12.6204C22.0525 11.9481 22.552 11.4482 23.2237 11.4482H27.771C28.3908 11.4482 28.8387 11.8963 28.8387 12.4998C28.8387 13.0857 28.3908 13.5513 27.771 13.5513H24.2912V15.482H25.48C27.6333 15.4823 29.4243 16.8616 29.4243 19.0854Z"
			fill="white"
		/>
		<defs>
			<filter
				id="filter0_dd_25188_21640"
				x="0"
				y="0"
				width="50"
				height="58"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25188_21640" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_25188_21640" result="effect2_dropShadow_25188_21640" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_25188_21640" result="shape" />
			</filter>
		</defs>
	</svg>
)
